module.exports = __webpack_public_path__ + "img/snowmelt.d9d65df9.png";